<template>
    <div id="event_Calendar" :class="checkMobileStatus ? 'mobile-view' : 'web-view'">

<!--        <div class="mobile-version-div" v-if="checkMobileStatus">-->

<!--        </div>-->

<!--        !checkMobileStatus && -->
        <div class="web-version-div" v-if="!isPostback">

            <div class="container">
                <div class="row header" style="margin-bottom: 30px;">
                    <div class="col-md-9">
                        <label class="event-page-title">{{lang("Event Overview")}}</label>

                        <button class="btn btn-tutorial" v-if="checkedUser !== 'Parent'">
                            <img src="../assets/Vector.png"/>
                            <span><a target="_blank" href="https://drive.google.com/file/d/1wc7Q72MX5lUZwl45NZCVXTBsP0gYzsYo/view?usp=sharing">
                                {{lang("Tutorial")}}
                            </a></span>
                        </button>
                    </div>

                    <div class="col-md-3" style="text-align: right;">
                        <button class="btn btn-create-calendar" v-on:click="eventNewEdit('NewfromButton')" v-if="checkedUser !== 'Parent'"
                                id="v-step-eventCreateNewEvent">
                            <img src="../assets/Vector1.png"/>
                            <span>{{lang("Create")}}{{lang("Calendar")}}</span>
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-tabs class="eventPageBTabs" v-show="checkedUser !== 'Parent'">
                            <b-tab class="tab-my-posts" :title="lang('My Calendar')"
                                   @click="showLatest ? '' : changeEventsStatus('Self')">
                                <div class="calendar-header col-md-12">

                                    <div class="calendar-header-left col-md-6" :class="showLatest ? 'upcoming-list' : ''">
                                        <div v-if="!showLatest">
                                            <button class="btn btn-prev-calendar" @click="onChangeNavi('prev')">
                                                <i class="fa fa-angle-left calendar-prev-button" aria-hidden="true"
                                                   data-action="move-prev"></i>
                                            </button>

                                            <span class="calendar-showing-date">{{dateRange}}</span>

                                            <button class="btn btn-next-calendar" @click="onChangeNavi('next')">
                                                <i class="fa fa-angle-right calendar-next-button" aria-hidden="true"
                                                   data-action="move-next"></i>
                                            </button>

                                            <div class="calendar-display-type">
                                                <span class="calendar-daily common-display-type" @click="changeCalendarDisplayType('day')"
                                                      :style="selectedView === 'day' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Daily")}}
                                                </span>
                                                <span class="calendar-weekly common-display-type" @click="changeCalendarDisplayType('week')"
                                                      :style="selectedView === 'week' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Weekly")}}
                                                </span>
                                                <span class="calendar-monthly common-display-type" @click="changeCalendarDisplayType('month')"
                                                      :style="selectedView === 'month' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Monthly")}}
                                                </span>
                                            </div>
                                        </div>

                                        <div v-if="showLatest">
                                            <span class="" style="color: #ffffff; font-size: 18px;">{{lang("Upcoming Events")}}</span>
                                        </div>
                                    </div>

                                    <div class="calendar-header-right col-md-6">
                                        <div class="calendar-view" @click="showUpComing('calendar')">
                                            <img v-if="!showLatest" src="../assets/Vector2.png" style="margin-right: 10px;"/>
                                            <img v-if="showLatest" src="../assets/Vector2-1.png" style="margin-right: 10px;"/>
                                        </div>

                                        <div class="calendar-list-view" @click="showUpComing('list')">
                                            <img v-if="!showLatest" src="../assets/Vector3.png" style="margin-right: 10px;"/>
                                            <img v-if="showLatest" src="../assets/Vector3-1.png" style="margin-right: 10px;"/>
                                        </div>

                                        <div class="calendar-header-right-button" style="display: inline-block; text-align: left;">
                                            <button class="btn btn-today" v-if="!showLatest" @click="onChangeNavi('today')">
                                                <img src="../assets/Vector4.png" style="margin-right: 10px;"/>
                                                <span style="color: #ffffff;">{{lang("Today")}}</span>
                                            </button>

<!--                                            <button class="btn btn-postback" @click="viewPostbackPage()">-->
<!--                                                <img src="../assets/Vector5.png" style="margin-right: 10px;"/>-->
<!--                                                <span style="color: #ffffff;">{{lang("Postback")}}</span>-->
<!--                                            </button>-->

                                            <button class="btn btn-copy" @click="showCopyEventModal()" id="v-step-eventCopyEvent">
                                                <img src="../assets/Vector6.png" style="margin-right: 10px;"/>
                                                <span style="color: #ffffff;">{{lang("Copy")}}</span>
                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <div class="calendar-content col-md-12" style="background: #FFFFFF; padding: 20px;" id="v-step-eventEditEvent">
                                    <div v-if="!showLatest">
                                        <calendar style="height: 800px"
                                                  ref="tuiCalSelf"
                                                  :useDetailPopup="false"
                                                  :useCreationPopup="false"
                                                  :view="selectedView"
                                                  :calendars="calendarList"
                                                  :schedules="scheduleList"
                                                  :template="template"
                                                  :taskView="false"
                                                  :scheduleView="true"
                                                  :theme="theme"
                                                  :month="month"
                                                  :week="week"
                                                  :timezones="timezones"
                                                  :disableDblClick="true"
                                                  :isReadOnly="false"
                                                  @beforeCreateSchedule="beforeCreateSchedule"
                                                  @clickSchedule="onClickSchedule"
                                        />
                                    </div>

                                    <div v-if="showLatest">
                                        <div class="latestEventList">
                                            <data-tables :data="upComingEventList" :action-col="eventListAction">
                                                <el-table-column v-for="item in eventListTable" min-width="50px"
                                                                 :prop="item.prop"
                                                                 :label="item.label" :key="item.prop"
                                                                 sortable="custom">
                                                </el-table-column>
                                            </data-tables>
                                        </div>
                                    </div>

                                </div>
                            </b-tab>

                            <b-tab class="tab-all-posts" :title="lang('All Calendar')"
                                   @click="showLatest ? '' : changeEventsStatus('All')">
                                <div class="calendar-header col-md-12">

                                    <div class="calendar-header-left col-md-6" :class="showLatest ? 'upcoming-list' : ''">
                                        <div v-if="!showLatest">
                                            <button class="btn btn-prev-calendar" @click="onChangeNavi('prev')">
                                                <i class="fa fa-angle-left calendar-prev-button" aria-hidden="true"
                                                   data-action="move-prev"></i>
                                            </button>

                                            <span class="calendar-showing-date">{{dateRange}}</span>

                                            <button class="btn btn-next-calendar" @click="onChangeNavi('next')">
                                                <i class="fa fa-angle-right calendar-next-button" aria-hidden="true"
                                                   data-action="move-next"></i>
                                            </button>

                                            <div class="calendar-display-type">
                                                <span class="calendar-daily common-display-type" @click="changeCalendarDisplayType('day')"
                                                      :style="selectedView === 'day' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Daily")}}
                                                </span>
                                                <span class="calendar-weekly common-display-type" @click="changeCalendarDisplayType('week')"
                                                      :style="selectedView === 'week' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Weekly")}}
                                                </span>
                                                <span class="calendar-monthly common-display-type" @click="changeCalendarDisplayType('month')"
                                                      :style="selectedView === 'month' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Monthly")}}
                                                </span>
                                            </div>
                                        </div>

                                        <div v-if="showLatest">
                                            <span class="" style="color: #ffffff; font-size: 18px;">{{lang("Upcoming Events")}}</span>
                                        </div>
                                    </div>

                                    <div class="calendar-header-right col-md-6">
                                        <div class="calendar-view" @click="showUpComing('calendar')">
                                            <img v-if="!showLatest" src="../assets/Vector2.png" style="margin-right: 10px;"/>
                                            <img v-if="showLatest" src="../assets/Vector2-1.png" style="margin-right: 10px;"/>
                                        </div>

                                        <div class="calendar-list-view" @click="showUpComing('list')">
                                            <img v-if="!showLatest" src="../assets/Vector3.png" style="margin-right: 10px;"/>
                                            <img v-if="showLatest" src="../assets/Vector3-1.png" style="margin-right: 10px;"/>
                                        </div>

                                        <div class="calendar-header-right-button" style="display: inline-block">
                                            <button class="btn btn-today" v-if="!showLatest" @click="onChangeNavi('today')">
                                                <img src="../assets/Vector4.png" style="margin-right: 10px;"/>
                                                <span style="color: #ffffff;">{{lang("Today")}}</span>
                                            </button>

<!--                                            <button class="btn btn-postback" @click="viewPostbackPage()">-->
<!--                                                <img src="../assets/Vector5.png" style="margin-right: 10px;"/>-->
<!--                                                <span style="color: #ffffff;">{{lang("Postback")}}</span>-->
<!--                                            </button>-->

                                            <button class="btn btn-copy" @click="showCopyEventModal()">
                                                <img src="../assets/Vector6.png" style="margin-right: 10px;"/>
                                                <span style="color: #ffffff;">{{lang("Copy")}}</span>
                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <div class="calendar-content col-md-12" style="background: #FFFFFF; padding: 20px;">
                                    <div v-if="!showLatest">
                                        <calendar style="height: 800px"
                                                  ref="tuiCalAll"
                                                  :useDetailPopup="false"
                                                  :useCreationPopup="false"
                                                  :view="selectedView"
                                                  :calendars="calendarList"
                                                  :schedules="scheduleList"
                                                  :template="template"
                                                  :taskView="false"
                                                  :scheduleView="true"
                                                  :theme="theme"
                                                  :month="month"
                                                  :week="week"
                                                  :timezones="timezones"
                                                  :disableDblClick="true"
                                                  :isReadOnly="false"
                                                  @beforeCreateSchedule="beforeCreateSchedule"
                                                  @clickSchedule="onClickSchedule"
                                        />
                                    </div>

                                    <div v-if="showLatest">
                                        <div class="latestEventList">
                                            <data-tables :data="upComingEventList" :action-col="eventListAction">
                                                <el-table-column v-for="item in eventListTable" min-width="50px"
                                                                 :prop="item.prop"
                                                                 :label="item.label" :key="item.prop"
                                                                 sortable="custom">
                                                </el-table-column>
                                            </data-tables>
                                        </div>
                                    </div>

                                </div>
                            </b-tab>
                        </b-tabs>

                        <b-tabs class="eventPageBTabs" v-if="checkedUser === 'Parent'">
                            <b-tab class="tab-all-posts" :title="lang('All Calendar')" @click="changeEventsStatus('All')">
                                <div class="calendar-header col-md-12">

                                    <div class="calendar-header-left col-md-6" :class="showLatest ? 'upcoming-list' : ''">
                                        <div v-if="!showLatest">
                                            <button class="btn btn-prev-calendar" @click="onChangeNavi('prev')">
                                                <i class="fa fa-angle-left calendar-prev-button" aria-hidden="true"
                                                   data-action="move-prev"></i>
                                            </button>

                                            <span class="calendar-showing-date">{{dateRange}}</span>

                                            <button class="btn btn-next-calendar" @click="onChangeNavi('next')">
                                                <i class="fa fa-angle-right calendar-next-button" aria-hidden="true"
                                                   data-action="move-next"></i>
                                            </button>

                                            <div class="calendar-display-type">
                                                <span class="calendar-daily common-display-type" @click="changeCalendarDisplayType('day')"
                                                      :style="selectedView === 'day' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Daily")}}
                                                </span>
                                                <span class="calendar-weekly common-display-type" @click="changeCalendarDisplayType('week')"
                                                      :style="selectedView === 'week' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Weekly")}}
                                                </span>
                                                <span class="calendar-monthly common-display-type" @click="changeCalendarDisplayType('month')"
                                                      :style="selectedView === 'month' ? {'color': '#FFFFFF'} : {'color': '#00196F'}">
                                                    {{lang("Monthly")}}
                                                </span>
                                            </div>
                                        </div>

                                        <div v-if="showLatest">
                                            <span class="" style="color: #ffffff; font-size: 18px;">{{lang("Upcoming Events")}}</span>
                                        </div>
                                    </div>

                                    <div class="calendar-header-right col-md-6">
                                        <div class="calendar-view" @click="showUpComing('calendar')">
                                            <img v-if="!showLatest" src="../assets/Vector2.png" style="margin-right: 10px;"/>
                                            <img v-if="showLatest" src="../assets/Vector2-1.png" style="margin-right: 10px;"/>
                                        </div>

                                        <div class="calendar-list-view" @click="showUpComing('list')">
                                            <img v-if="!showLatest" src="../assets/Vector3.png" style="margin-right: 10px;"/>
                                            <img v-if="showLatest" src="../assets/Vector3-1.png" style="margin-right: 10px;"/>
                                        </div>

                                        <div class="calendar-header-right-button" style="display: inline-block">
                                            <button class="btn btn-today" v-if="!showLatest" @click="onChangeNavi('today')">
                                                <img src="../assets/Vector4.png" style="margin-right: 10px;"/>
                                                <span style="color: #ffffff;">{{lang("Today")}}</span>
                                            </button>

                                            <!--                                            <button class="btn btn-postback" @click="viewPostbackPage()">-->
                                            <!--                                                <img src="../assets/Vector5.png" style="margin-right: 10px;"/>-->
                                            <!--                                                <span style="color: #ffffff;">{{lang("Postback")}}</span>-->
                                            <!--                                            </button>-->

                                            <button class="btn btn-copy" @click="showCopyEventModal()">
                                                <img src="../assets/Vector6.png" style="margin-right: 10px;"/>
                                                <span style="color: #ffffff;">{{lang("Copy")}}</span>
                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <div class="calendar-content col-md-12" style="background: #FFFFFF; padding: 20px;">
                                    <div v-if="!showLatest">
                                        <calendar style="height: 800px"
                                                  ref="tuiCalAll"
                                                  :useDetailPopup="false"
                                                  :useCreationPopup="false"
                                                  :view="selectedView"
                                                  :calendars="calendarList"
                                                  :schedules="scheduleList"
                                                  :template="template"
                                                  :taskView="false"
                                                  :scheduleView="true"
                                                  :theme="theme"
                                                  :month="month"
                                                  :week="week"
                                                  :timezones="timezones"
                                                  :disableDblClick="true"
                                                  :isReadOnly="false"
                                                  @beforeCreateSchedule="beforeCreateSchedule"
                                                  @clickSchedule="onClickSchedule"
                                        />
                                    </div>

                                    <div v-if="showLatest">
                                        <div class="latestEventList">
                                            <data-tables :data="upComingEventList" :action-col="eventListAction">
                                                <el-table-column v-for="item in eventListTable" min-width="50px"
                                                                 :prop="item.prop"
                                                                 :label="item.label" :key="item.prop"
                                                                 sortable="custom">
                                                </el-table-column>
                                            </data-tables>
                                        </div>
                                    </div>

                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

            </div>

        </div>

        <div v-if="isPostback" style="text-align: left; margin: 0px;">
            <div class="postback-header-container" style="margin-bottom: 20px;">
                <span class="sans-font-style-size-22" style="color: #536170;">Postback List</span>
            </div>

            <div class="row" style="margin: 0px;">
                <div class="parent-postback-list-container">
                    <div class="empty-postback-list" v-if="eventPostBackList.length <= 0" style="text-align: center;">
                        <img src="../assets/notif1.png"/>
                        <span class="sans-font-style-size-18" style="display: block;">{{empty_message}}</span>
                    </div>

                    <div class="each-parent-postback-container" v-if="eventPostBackList.length > 0">
                        <div class="each-parent-postback" v-for="(eachPbList, pbIndex) in eventGroupPostBackList">

                        </div>
                    </div>
                </div>

                <div class="postback-content-container">
                    <div class="selected-event" style="position: relative;">
                        <select v-model="postBackSelectedEventID" placeholder="Please select event name" style="margin-bottom: 20px; background: #f7f7f7;"
                                class="w-100 form-control" @change="changePostbackSelectedEvent()">
                            <option v-for="eventItem in eventList"
                                    class="ddlEndResultEventOption"
                                    :key="eventItem.EventID"
                                    :label="eventItem.EventTitle + ' ('+convertDatetimeFormat(eventItem.EventStartTime)+')'"
                                    :value="eventItem.EventID" style="max-width: 100%">
                            </option>
                        </select>
                    </div>

                    <div class="selected-postback-list" v-if="eventGroupPostBackList.length > 0">
                        <div style="text-align: right; margin-bottom: 20px;">
                            <el-button class="el-button--primary" @click="downloadAsZip()">
                                <img src="../assets/Vector7.png" style="margin-right: 10px;"/>
                                <span>Download All</span>
                            </el-button>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <b-modal id="create_event_modal" size="xl" :title="/*lblNewEditCalendar +*/ lang('Create')+lang('Event')" ref="EventShowModal"
                 hide-footer hide-header
                 ok-variant="secondary">
            <Event_Modal_Component
                    :isDisable="isDisabled"
                    :lblNewEditEvent="lblNewEditCalendar"
                    @LoadEventDetails="LoadEventDetails"
                    @hideEventShowModal="hideEventShowModal"
                    @refreshBModalValue="refreshBModalValue"
                    @deleteEvent="deleteEvent"
                    @eventNewEdit="eventNewEdit"
                    @showClassModal="showClassModal"
                    :eventCheckedUser="checkedUser"
                    :eventStudentInt="studentInt"
                    :eventInputEventTitle="inputEventTitle"
                    :eventInputEventTime="inputEventTime"
                    :eventOptParentSignUp="optParentSignUp"
                    :eventRdEventType="rdEventType"
                    :eventInputEventRegLimit="inputEventRegLimit"
                    :eventInputEventRegCutOffDay="inputEventRegCutOffDay"
                    :eventInputEventRegistrationStartTime="inputEventRegistrationStartTime"
                    :eventInputEventLocation="inputEventLocation"
                    :eventGuestInt="guestInt"
                    :eventDurationHour="EventDurationHour"
                    :eventID="selectedEventID"
                    :eventFiles="arrobj_SelectedFiles"
                    :eventPtcPar="arrobj_ptcParticipant"
                    :hangoutEventLink="hangoutEventLink"
                    :googleCalendarEventID="googleCalendarEventID"
                    :paramEventCreatedBy="eventCreatedBy"
                    :paramTeacherIds="assTeacherIds"
                    :paramPierTeachersIds="pierTeachersIds"
                    :paramClassTeacherIds="classTeacherIds"
                    :paramEventCreatedOn="eventCreatedOn"
                    :paramEventCreatorName="eventCreatorName"
                    :paramEventRemark="eventRemark"
                    :paramEventFormat="eventFormat"
                    :paramServerCurrentDatetime="serverCurrentDatetime"
            />
        </b-modal>

        <b-modal id="copyEventModal" size="lg" :title="lang('Copy Event')" ref="copyEventModal"
                 hide-footer hide-header style="padding: 0px;">
            <div class="row" style="padding: 20px;">
                <div class="col-md-12">
                    <label style="font-weight: normal; font-size: 24px;">{{lang('Copy Event')}}</label>
                </div>

                <div class="col-md-6">
                    <label style="font-weight: normal;">{{lang("Event")}}</label>
                    <select v-model="eventCopyEventID" placeholder="Please select event name"
                            style="margin-bottom: 20px; background: #f7f7f7; padding: 0px;"
                            class="w-100 form-control" @change="changeSelectedEvent()">
                        <option v-for="eventItem in eventList"
                                class="ddlEndResultEventOption"
                                :key="eventItem.EventID"
                                :label="eventItem.EventTitle + ' ('+convertDatetimeFormat(eventItem.EventStartTime)+')'"
                                :value="eventItem.EventID" style="max-width: 100%">
                        </option>
                    </select>
                </div>

                <div class="col-md-6">
                    <!--                        <label style="font-weight: normal;">From Date to Date</label>-->
                    <label style="font-weight: normal;">Start Date - End Date</label>

                    <div class="event-start-datetime col-md-4" style="display: inline-block; padding: 0px;">
                        <datetime
                                input-id="start-datetime"
                                input-class="start-datetime"
                                type="datetime"
                                :min-datetime="evtMinDate"
                                format="dd/MM/yyyy HH:mm"
                                v-model="evtStartDatetime"
                                placeholder="Start Date">
                        </datetime>
                    </div>
                    <span> to </span>
                    <div class="event-end-datetime col-md-4" style="display: inline-block; padding: 0px;">
                        <datetime
                                input-id="end-datetime"
                                input-class="end-datetime"
                                type="datetime"
                                :min-datetime="evtStartDatetime"
                                format="dd/MM/yyyy HH:mm"
                                v-model="evtEndDatetime"
                                placeholder="End Date">
                        </datetime>
                    </div>

                    <div class="add-multiple-datetime-button col-md-2" style="display: inline-block; ">
                        <button class="btn btn-primary" @click="addCopyDatetime()" style="padding: 5px 15px; min-width: auto;">{{lang("Add")}}</button>
                    </div>
                </div>

                <div class="added-copy-datetime-list col-md-12" v-if="!isNull(copyEventDateList)" style="margin-bottom: 10px;">
                    <small style="color: red;">* Only allow 3 datetime</small>
                    <div v-for="(dateList, lIndex) in copyEventDateList" style="padding: 5px; border: 1px solid #DDE6FC;">

                        <span style="color: #426DFF; font-weight: bold;">| {{(lIndex+1)}}</span>
                        <span style="margin-left: 10px;">
                                {{convertDatetimeFormat(dateList.copyStart)}} - {{convertDatetimeFormat(dateList.copyEnd)}}
                            </span>

                        <div style="float: right" @click="removeCopyDate(dateList)">
                            <i class="fa fa-trash-o" style="font-size:24px"></i>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>

            <div class="copy-footer" style="padding: 20px;">
                <div class="col-md-6" style="display: inline-block; padding: 0px;">
                    <button class="btn" @click="hideCopyEventModal()"
                            style="background: #606265; border-radius: 5px; color: #ffffff">CLOSE</button>
                </div>

                <div class="col-md-6" style="display: inline-block; padding: 0px; text-align: right;">
                    <button class="btn btn-primary" @click="copyEvent()">{{lang("Confirm")}}</button>
                </div>
            </div>

            <!--                <div class="selected-event">-->
            <!--                    <select v-model="eventCopyEventID" placeholder="Please select event name"-->
            <!--                            style="margin-bottom: 20px; background: #f7f7f7; padding: 0px;"-->
            <!--                            class="w-100 form-control" @change="changeSelectedEvent()">-->
            <!--                        <option v-for="eventItem in eventList"-->
            <!--                                class="ddlEndResultEventOption"-->
            <!--                                :key="eventItem.EventID"-->
            <!--                                :label="eventItem.EventTitle + ' ('+convertDatetimeFormat(eventItem.EventStartTime)+')'"-->
            <!--                                :value="eventItem.EventID" style="max-width: 100%">-->
            <!--                        </option>-->
            <!--                    </select>-->
            <!--                </div>-->

            <!--                <div class="select-datetime" style="margin-bottom: 15px;" v-if="copyEventDateList.length < 3">-->
            <!--                    <div class="event-start-datetime">-->
            <!--                        <small>{{lang("Select Start Datetime")}}</small>-->
            <!--                        &lt;!&ndash;                {{inputEventTime}}&ndash;&gt;-->
            <!--                        <datetime-->
            <!--                                input-id="start-datetime"-->
            <!--                                input-class="start-datetime"-->
            <!--                                type="datetime"-->
            <!--                                :min-datetime="evtMinDate"-->
            <!--                                format="dd/MM/yyyy HH:mm"-->
            <!--                                v-model="evtStartDatetime">-->
            <!--                        </datetime>-->
            <!--                    </div>-->

            <!--                    <div class="event-end-datetime">-->
            <!--                        <small>{{lang("Select End Datetime")}}</small>-->

            <!--                        <datetime-->
            <!--                                input-id="end-datetime"-->
            <!--                                input-class="end-datetime"-->
            <!--                                type="datetime"-->
            <!--                                :min-datetime="evtStartDatetime"-->
            <!--                                format="dd/MM/yyyy HH:mm"-->
            <!--                                v-model="evtEndDatetime">-->
            <!--                        </datetime>-->
            <!--                    </div>-->

            <!--                    <div class="add-multiple-datetime-button" style="margin-top: 10px;">-->
            <!--                        <button class="btn btn-primary" @click="addCopyDatetime()">{{lang("Add")}}</button>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <div class="added-copy-datetime-list" v-if="!isNull(copyEventDateList)" style="margin-bottom: 10px;">-->
            <!--                    <small style="color: red;">* Only allow 3 datetime</small>-->
            <!--                    <div v-for="(dateList, lIndex) in copyEventDateList" style="margin-bottom: 10px;">-->
            <!--                        <label style="display: inline-block!important; margin: 0 10px 0 0; vertical-align: middle">-->
            <!--                            <span>{{(lIndex+1)}} ) </span> {{convertDatetimeFormat(dateList.copyStart)}} - {{convertDatetimeFormat(dateList.copyEnd)}}-->
            <!--                        </label>-->
            <!--                        <button class="btn btn-danger" @click="removeCopyDate(dateList)">{{lang("Remove")}}</button>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <div style="text-align: right;">-->
            <!--                    <button class="btn btn-primary" @click="copyEvent()">{{lang("Confirm")}}</button>-->
            <!--                </div>-->
        </b-modal>

        <b-modal id="addClassModal" hide-footer size="lg"
                 :title="lang('Add')+lang('Student')" ref="addClassModal">
            <EventTagsComponent @tags="setTags" :parent_Post="post"></EventTagsComponent>
            <button class="btn btn-primary" v-on:click="AddComponentValue()">{{lang("Add")}}{{lang("Student")}}</button>
        </b-modal>

        <b-modal id="create_event_modal_nonStaff" size="xl" :title='lang("Join")+lang("Event")' ref="EventShowModalNonStaff"
                 hide-footer
                 ok-variant="secondary">
            <Event_Parent
                    :propJoinEventDetails="joinEventDetails"
                    :propEventAllParticipant="EventAllParticipant"
                    :propEventID="selectedEventID"
                    :eventRdEventType="rdEventType"
                    :propArrobj_SelectedFiles="arrobj_SelectedFiles"
                    @hideNonStaffEventModal="hideNonStaffEventModal"
                    :paramServerCurrentDatetime="serverCurrentDatetime"
                    @rerenderInit="init"
            />
        </b-modal>

        <b-modal id="create_end_result_modal" size="xl" title="Create" centered ok-title="Submit" @hidden="hideEndResultModal"
                 @ok="createEndResult" :cancel-title="lang('Cancel')" @cancel="hideEndResultModal" ref="parentShowEndResultModal">
            <div class="end-result-content-container">
                <div class="selected-event">
                    <el-select v-model="ddlEndResultEventID" placeholder="Please select event name" style="margin-bottom: 20px;"
                               class="w-100">
                        <el-option v-for="eventItem in eventList"
                                   class="ddlEndResultEventOption"
                                   :key="eventItem.EventID"
                                   :label="eventItem.EventTitle + ' ('+convertDatetimeFormat(eventItem.EventStartTime)+')'"
                                   :value="eventItem.EventID">
                        </el-option>
                    </el-select>
                </div>

                <div class="end-result-remark">
                    <label>Remarks</label>
                    <el-input v-model="endResultRemarks" type="textarea" :rows="6" maxlength="3000" placeholder="Please input remarks">

                    </el-input>
                </div>

                <div class="end-result-files">
                    <input type="file" @change="onFileChanged" multiple class="inputfile"
                           id="FU_Portfolio"/>
                    <label for="FU_Portfolio">{{lang("Select File(s)")}}</label>

                    <div v-if="arrobj_EndResultSelectedFiles && arrobj_EndResultSelectedFiles.length > 0"
                         v-for="(obj_Images, key) of arrobj_EndResultSelectedFiles"
                         :key="(obj_Images, key).id" style="position: relative;">
                        <label>
                            <span v-if="obj_Images.name">{{obj_Images.name}}</span>
                            <span v-if="obj_Images.EventFIleName">{{obj_Images.EventFIleName}}</span>
                            <span class="each-file-close" @click="cancelFiles(obj_Images, key)"><span style="vertical-align: text-bottom;">x</span></span>
                        </label>
                    </div>
                </div>
            </div>

            <!--                    <div class="end-result-footer-container">-->
            <!--                        -->
            <!--                    </div>-->
        </b-modal>

        <v-tour name="EventPageVueTourName" :steps="eventPageVueTour" :options="eventPageVueTourOptions"
                :callbacks="eventPageVueTourCallBacks">
            <template slot-scope="tour">
                <transition name="fade">
                    <v-step
                            v-if="tour.currentStep === index"
                            v-for="(step, index) of tour.steps"
                            :key="index"
                            :step="step"
                            :previous-step="tour.previousStep"
                            :next-step="tour.nextStep"
                            :stop="tour.stop"
                            :is-first="tour.isFirst"
                            :is-last="tour.isLast"
                            :labels="tour.labels"
                    >
                        <template v-if="tour.currentStep > 1 && tour.currentStep < index">
                            <div slot="actions">
                                <button class="v-step__button" @click="tour.stop">Skip tour</button>
                                <button class="v-step__button" @click="tour.previousStep">
                                    Previous
                                </button>
                                <button class="v-step__button" @click="tour.nextStep">Next</button>
                            </div>
                        </template>
                    </v-step>
                </transition>
            </template>
        </v-tour>

    </div>
</template>
<script>
    import DataSource from "../data/datasource";
    import EventTagsComponent from "../components/Event_Tags_Component";
    import Event_Modal_Component from "../components/Event/Event_Modal_Component";
    import Event_Parent from "../components/Event/Event_ParentModal_Component";
    import Cookies from "js-cookie";
    import {fullCalendar} from "vue-fullcalendar";
    import 'tui-calendar/dist/tui-calendar.css';
    import {Calendar} from '@toast-ui/vue-calendar';
    import moment from 'moment';
    import {lang} from '../locale/index';
    import $ from "jquery";
    import Vue from 'vue';
    import { Datetime } from 'vue-datetime';
    // You need a specific loader for CSS files
    import 'vue-datetime/dist/vue-datetime.css';
    import EventPostBack from "../pages/EventPostBack";

    Vue.use(Datetime);

    // import Event_Modal_Component from "../components/testCreateEventModalComponent";

    const today = new Date();
    const getDate = (type, start, value, operator) => {
        start = new Date(start);
        type = type.charAt(0).toUpperCase() + type.slice(1);
        if (operator === '+') {
            start[`set${type}`](start[`get${type}`]() + value);
        } else {
            start[`set${type}`](start[`get${type}`]() - value);
        }
        return start;
    };


    export default {
        name: "StaffEventCalendar",
        components: {
            EventTagsComponent,
            'calendar': Calendar,
            Event_Modal_Component,
            Event_Parent,
            datetime: Datetime,
        },
        props: ["images", "post", "paramTourData"],
        async created() {
            this.isPostback = false;
            this.getServerCurrentDatetime();

            if (Cookies.get('userTypeSession') === 'Parent') {
                this.isStaff = false;
                // await this.LoadEventDetails();
                await this.LoadUpComingEvent();
                await this.loadWhitelist();
            } else {
                this.isStaff = true;
                // await this.LoadProfileImg();
                // await this.LoadEventDetails();
                await this.LoadUpComingEvent();
                // await this.BindParticipantList();
                await this.getLevelSpecificSchool();
            }

            if (Cookies.get('userTypeSession') === 'Parent') {
                if (!this.isNull(Cookies.get('userSchoolInfoSerializeSession')) && Cookies.get('userSchoolInfoSerializeSession') !== "Nill - Nill") {
                    this.userSchoolInfoSerialize = Cookies.get('userSchoolInfoSerializeSession');
                    this.userSchoolInfoSerialize = JSON.parse(this.userSchoolInfoSerialize);
                    this.userSchoolInfoSerialize = this.userSchoolInfoSerialize.Table;
                }
            }

            if (!this.isNull(this.paramTourData)) {
                this.eventPageVueTourStart();
            }

            // UserSchoolInfoSerialize_Session
            window.addEventListener('resize', this.isMobile);
        },
        async mounted() {
            this.userType = Cookies.get('userTypeSession');
            this.sessionID = Cookies.get('userIDSession');
            this.schID = Cookies.get('schoolSession');
            if (Cookies.get('userTypeSession') === 'Parent') {
                this.eventDisplayMode = "All";
            }
            this.init();
            this.checkUser();

            this.isMobile();

            // if (this.userType === 'Parent') {
            //     let self = this;
            //     $("#FU_Portfolio").on("change", function (e) {
            //         console.log("hihi");
            //         self.onFileChanged(e);
            //     });
            // }
        },
        data() {
            return {
                //Start: class component
                spdSelection: [],
                tags: [],
                guestInt: [],
                EventAllParticipant: [],
                studentInt: [],
                inputVisible: false,
                inputValue: '',
                guestList: [
                    {
                        prop: "value",
                        label: lang("Guest")+lang("Email")
                    },
                    {
                        prop: "Type",
                        label: lang("Guest")+lang("Type")
                    }
                ],
                eventListAction: {
                    label: lang("View"),
                    props: {
                        align: 'right',
                    },
                    buttons: [{
                        props: {
                            type: 'primary',
                            icon: 'el-icon-view'

                        },
                        handler: row => {
                            this.editEvent(row);
                        },
                        label: ''
                    }]
                },
                guestListAction: {
                    label: lang("Delete"),
                    props: {
                        align: 'center',
                    },
                    buttons: [{
                        props: {
                            type: 'primary',
                            icon: 'el-icon-delete'

                        },
                        handler: row => {
                            this.guestInt.splice(this.guestInt.indexOf(row), 1);
                        },
                        label: lang("Delete")
                    }]
                },
                userType: "",
                isStaff: '',
                imgStaffProfile: '',
                //
                obj_SelectedComponent: "",
                str_PostComponentTitle: "",
                arrobj_SelectedItem: [],
                obj_ComponentProperties: {},
                //
                upComingDetailClicked: false,
                isDisabled: false,
                datePicker: {
                    disabledDate(date) {
                        return date < (new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
                    }
                },
                ddlParticipant: '',
                selectedParticipantList: [],
                rdEventType: '',
                rdEventTypeList: [
                    {
                        value: 'Event',
                        label: 'Event'
                    }, {
                        value: 'SchoolClosure',
                        label: 'School Closure'
                    }, {
                        value: 'PublicHoliday',
                        label: 'Public Holiday'
                    }
                ],
                eventList: [],
                latestEventList: [],
                levelList: [],
                inputEventTime: [],
                inputEventRegistrationStartTime: '',
                EventDurationHour: '',
                optParentSignUp: false,
                inputEventRegCutOffDay: 0,
                inputEventRegLimit: 0,
                inputEventTitle: '',
                inputEventLocation: '',
                inputEventParticipant: "",
                inputEventParticipantList: [],
                inputEventDesc: '',
                selectedEventID: '',
                ddlClassLevel: '',
                //Full Calendar
                mode: 'single',
                selectedDate: null,
                sessionID: '',
                lblNewEditCalendar: '',
                MasterParticipantList: [],
                CurrentParticipantList: [],
                ParticipantNameListIntTemp: [],
                ParticipantNameListInt: [],
                tempParticipantList: [],
                ParticipantNameListAction: {
                    label: lang("Delete"),
                    props: {
                        align: 'center',
                    },
                    buttons: [{
                        props: {
                            type: 'primary',
                            icon: 'el-icon-edit'
                        },
                        handler: row => {

                            this.ParticipantNameListInt.splice(this.ParticipantNameListInt.indexOf(row), 1);
                            this.selectedParticipantList.splice(this.selectedParticipantList.indexOf(row), 1);
                            let objValue = {
                                CONname: row.StAllItem,
                                CONEmail: row.SelectedConEmail,
                                CONid: row.SelectedConID,
                                EventParID: row.SelectedEventParID,
                            };
                            this.CurrentParticipantList.push(objValue);

                        },
                        label: lang("Delete")
                    }]
                },
                ParticipantNameList: [{
                    prop: "StAllItem",
                    label: lang("Email Address")
                }],
                showLatest: false,

                //calendar option
                viewModeOptions: [
                    {
                        title: lang("Monthly"),
                        value: 'month'
                    },
                    {
                        title: lang("Weekly"),
                        value: 'week'
                    },
                    {
                        title: lang("Daily"),
                        value: 'day'
                    }
                ],
                dateRange: '',
                selectedView: 'month',
                calendarList: [
                    {
                        id: 'PublicHoliday',
                        name: 'Public Holiday',
                        bgColor: '#9e5fff',
                        borderColor: '#9e5fff'
                    },
                    {
                        id: 'Event',
                        name: 'Event',
                        bgColor: '#00a9ff',
                        borderColor: '#00a9ff'
                    },
                    {
                        id: 'SchoolClosure',
                        name: 'SchoolClosure',
                        bgColor: '#ffc900',
                        borderColor: '#ffc900'
                    },
                    {
                        id: 'PTC',
                        name: 'PTC',
                        bgColor: '#69d5a1',
                        borderColor: '#69d5a1'
                    }
                ],
                scheduleList: [],
                timezones: [{
                    timezoneOffset: 480,
                    displayLabel: 'GMT+08:00',
                    tooltip: 'Singapore'
                }, {
                    timezoneOffset: -420,
                    displayLabel: 'GMT-08:00',
                    tooltip: 'Los Angeles'
                }],
                template: {
                    milestone(schedule) {
                        return `<span style="color:#fff;background-color: ${schedule.bgColor};">${schedule.title}</span>`;
                    },
                    milestoneTitle() {
                        return 'Milestone';
                    },
                    allday(schedule) {
                        return `${schedule.title}`;
                    },
                    alldayTitle() {
                        return 'All Day';
                    },
                    popupSave() {
                        return 'Saves';
                    },
                    popupDetailBody(schedule) {
                        return schedule.body;
                    },

                },
                month: {
                    startDayOfWeek: 0
                },
                week: {
                    showTimezoneCollapseButton: true,
                    timezonesCollapsed: true
                },
                checkedUser: "",
                isEditEvent: false,
                editEventID: "",
                theme: {
                    'month.dayname.height': '42px',
                },
                joinEventDetails: [],
                arrobj_SelectedFiles: [],

                eventListTable: [{
                    prop: "CONname",
                    label: lang("Created by")
                }, {
                    prop: "EventTitle",
                    label: lang("Event")+lang("Title")
                }, {
                    prop: "EventType",
                    label: lang("Event")+lang("Type")
                }, {
                    prop: "EventStartTime_DateTimeConvert",
                    label: lang("Event Start Date")
                }, {
                    prop: "EventEndTime_DateTimeConvert",
                    label: lang("Event End Date")
                },],

                checkMobileStatus: false,

                arrobj_ptcParticipant: [],
                upComingEventList: [],

                hangoutEventLink: '',
                googleCalendarEventID: '',

                ddlEndResultEventID: '',
                endResultRemarks: '',
                arr_EndResultSelectedFileList: [],
                arrobj_EndResultSelectedFiles: [],
                isUploadFile: false,
                userSchoolInfoSerialize: [],
                eventCreatedBy: '',
                eventDisplayMode: 'Self',
                assTeacherIds: '',
                pierTeachersIds: '',
                classTeacherIds: '',
                eventCreatedOn: '',
                eventCreatorName: '',
                eventRemark: '',
                eventFormat: '',
                eventListDateFrom: '',
                eventListDateTo: '',
                eventCopyEventID: '',
                evtStartDatetime: '',
                evtEndDatetime: '',
                evtMinDate: '',
                copyEventDateList: [],
                copyEventFiles: [],
                copyEventData: [],
                copyStartDatetime: '',
                copyEndDatetime: '',
                createdGoogleCalendarEventLink: '',
                createdGoogleCalendarID: '',
                schID: '',
                serverCurrentDatetime: '',

                // postback list
                eventPostBackList: [],
                eventGroupPostBackList: [],
                postBackSelectedEventID: '',
                selectedDisplayMode: 'NonParent', // NonParent <- get all record, Parent <- get only specific record

                empty_message: 'No Record Selected',
                accordionName: '',
                allPBIDs: [],
                isPostback: false,
                arr_parentSplit: [],


                //vue tour
                //https://github.com/pulsardev/vue-tour
                eventPageVueTourOptions: {
                    useKeyboardNavigation: false,
                    labels: {
                        buttonSkip: 'Skip tour',
                        buttonPrevious: 'Previous',
                        buttonNext: 'Next',
                        buttonStop: 'Finish'
                    }
                },
                eventPageVueTourCallBacks: {
                    onPreviousStep: this.eventPageVueTourCallBacksPreviousSteps,
                    onNextStep: this.eventPageVueTourCallBacksNextSteps
                },
                eventPageVueTour: [
                    {
                        target: '#v-step-eventCreateNewEvent',
                        content: `<div class="eventPageTourDiv">Step 1 / 3 <br> Click Create Calendar button <br> Then can choose which type event that you want to create.</div>`,
                        params: {
                            placement: 'bottom',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-eventCopyEvent',
                        content: `<div class="eventPageTourDiv">Step 2 / 3 <br> Click Copy button <br> Then select event title, start end date and click Add and Confirm button.</div>`,
                        params: {
                            placement: 'bottom',
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#v-step-eventEditEvent',
                        content: `<div class="eventPageTourDiv">Step 3 / 3 <br> Select 1 event that you want Edit/Delete.</div>`,
                        params: {
                            placement: 'bottom',
                            enableScrolling: false
                        }
                    },
                ],
                //vue tour
            };
        },
        watch: {
            selectedView(newValue) {
                if (this.eventDisplayMode === "Self") {
                    this.$refs.tuiCalSelf.invoke('changeView', newValue, true);
                } else {
                    this.$refs.tuiCalAll.invoke('changeView', newValue, true);
                }
                // this.$refs.tuiCal.invoke('changeView', newValue, true);
                this.setRenderRangeText();
            }
        },
        methods: {
            lang,
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
            hideEventShowModal() {
                this.$refs['EventShowModal'].hide();
                // this.$refs['EventShowModalNonStaff'].hide();
            },
            hideNonStaffEventModal() {
                this.$refs['EventShowModalNonStaff'].hide();
            },
            setTags(value) {
                try {
                    this.tags = value;

                } catch (e) {
                    this.results = e;
                }
            },
            AddComponentValue() {
                try {
                    if (this.tags) {
                        // this.$notify({
                        //     title: 'Success',
                        //     message: 'Successfully!',
                        //     type: 'success'
                        // });
                        this.$refs.addClassModal.hide();
                        let uniqueTags = [];
                        this.tags.forEach(object => {
                            const isExist = this.studentInt.find(m => m.value === object.Student_ID);
                            if (!isExist) {
                                uniqueTags.push(object);
                            }
                        });
                        uniqueTags.forEach(m => {
                            let my_object = {
                                Type: "Student",
                                value: m.Student_ID,
                                label: m.First_Name + " " + m.Middle_Name + " " + m.Last_Name,
                            };
                            this.studentInt.push(my_object);
                        });
                    } else {
                        this.$notify.error({
                            title: lang('Error, please try again'),
                            message: lang('Error')
                        });
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            showLoading() {
                this.$vs.loading();
            },
            hideLoading() {
                this.$vs.loading.close();
            },
            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },
            showMore(obj) {
                this.upComingDetailClicked = true;
                this.LoadUpComingEventDetail(obj);
            },
            async BindEventFields(resultTable) {
                try {
                    this.ParticipantNameListIntTemp = [];
                    this.ParticipantNameListInt = [];
                    this.CurrentParticipantList = [];

                    // resultTable.forEach(async m => {
                    resultTable.forEach((m) => {
                        this.inputEventTitle = m.EventTitle;
                        this.rdEventType = m.EventType;
                        // this.inputEventTime[0] = new Date(m.EventStartTime);
                        // this.inputEventTime[1] = new Date(m.EventEndTime);
                        this.inputEventTime[0] = moment(m.EventStartTime).format("DD/MM/YYYY HH:mm:ss");
                        this.inputEventTime[1] = moment(m.EventEndTime).format("DD/MM/YYYY HH:mm:ss");
                        this.inputEventRegLimit = m.EventRegLimit;
                        this.inputEventRegCutOffDay = m.EventRegCutOffDay;
                        this.inputEventLocation = m.EventLocation;
                        if (m.EventRegistrationStartTime !== undefined) {
                            this.inputEventRegistrationStartTime = new Date(m.EventRegistrationStartTime);
                        }
                        this.EventDurationHour = m.EventDuration;

                        this.hangoutEventLink = m.EventLink;
                        this.googleCalendarEventID = m.EventCalendarID;

                        this.eventCreatedBy = m.EventCreatedBy;
                        if (m.teachers) {
                            this.assTeacherIds = m.teachers;
                        }
                        if (m.pierteachers) {
                            this.pierTeachersIds = m.pierteachers;
                        }
                        if (m.classTeacher) {
                            this.classTeacherIds = m.classTeacher;
                        }
                        this.eventCreatedOn = moment(m.EventCreatedOn).format("DD MMM YYYY HH:mm:ss");
                        this.eventCreatorName = m.CONname;
                        this.eventRemark = m.EventRemarks;
                        this.eventFormat = m.EventFormat;

                        // const resp = await DataSource.shared.getEventParticipantByEventID(m.EventID);
                        // console.log(resp);
                        DataSource.shared.getEventParticipantByEventID(m.EventID).then((result) => {
                            // console.log(result);
                            if (result.code === '2') {
                                this.MasterParticipantList.forEach(m => {
                                    this.CurrentParticipantList.push(m);
                                });
                                this.guestInt = [];
                                this.studentInt = [];
                            } else {
                                const participantResponse = result.Table;
                                this.EventAllParticipant = result.Table;
                                let editParticipantTemp = [];

                                this.arrobj_ptcParticipant = participantResponse;

                                if (participantResponse !== undefined) {
                                    participantResponse.forEach(m => {
                                        let my_object = {
                                            Type: m.EventParType,
                                            value: m.PaxName,
                                        };
                                        editParticipantTemp.push(my_object);
                                    });
                                }

                                this.ParticipantNameListInt = editParticipantTemp;
                                this.guestInt = this.ParticipantNameListInt.filter(d => {
                                    return d.Type === "Others";
                                });

                                let studentIntFilter = [];
                                if (participantResponse !== undefined) {
                                    studentIntFilter = participantResponse.filter(d => {
                                        return d.EventParType === "Student";
                                    });
                                }

                                if (this.isStaff === false) {
                                    this.studentInt = studentIntFilter;
                                } else {
                                    let tempStudentInt = [];
                                    studentIntFilter.forEach(m => {
                                        let my_object = {
                                            Type: m.EventParType,
                                            value: m.EventParPaxID,
                                            label: m.PaxName
                                        };
                                        tempStudentInt.push(my_object);
                                    });
                                    this.studentInt = tempStudentInt;
                                }
                            }
                        });
                        // if (resp) {
                        //     if (resp.code === '2') {
                        //         this.MasterParticipantList.forEach(m => {
                        //             this.CurrentParticipantList.push(m);
                        //         });
                        //         this.guestInt = [];
                        //         this.studentInt = [];
                        //     } else {
                        //         const participantResponse = resp.Table;
                        //         this.EventAllParticipant = resp.Table;
                        //         let editParticipantTemp = [];
                        //         participantResponse.forEach(m => {
                        //             let my_object = {
                        //                 Type: m.EventParType,
                        //                 value: m.PaxName,
                        //             };
                        //             editParticipantTemp.push(my_object);
                        //         });
                        //         this.ParticipantNameListInt = editParticipantTemp;
                        //         this.guestInt = this.ParticipantNameListInt.filter(d => {
                        //             return d.Type === "Others";
                        //         });
                        //         let studentIntFilter = participantResponse.filter(d => {
                        //             return d.EventParType === "Student";
                        //         });
                        //         if (this.isStaff === false) {
                        //             this.studentInt = studentIntFilter;
                        //         } else {
                        //             let tempStudentInt = [];
                        //             studentIntFilter.forEach(m => {
                        //                 let my_object = {
                        //                     Type: m.EventParType,
                        //                     value: m.EventParPaxID,
                        //                     label: m.PaxName
                        //                 };
                        //                 tempStudentInt.push(my_object);
                        //             });
                        //             this.studentInt = tempStudentInt;
                        //         }
                        //
                        //
                        //     }
                        // }
                        if (m.EventParentSignUp === 'Yes') {
                            this.optParentSignUp = true;
                        }
                    });


                } catch (e) {
                    this.results = e;
                }
            },
            async editEvent(objValue) {
                try {
                    this.$vs.loading();
                    //capture EventID
                    let obj = {
                        eventID: objValue.EventID,
                        eventCreatedBy: objValue.EventCreatedBy,
                    };

                    this.selectedEventID = obj.eventID;
                    const response = await DataSource.shared.getEventDetails(this.selectedEventID);
                    this.refreshBModalValue(response);
                    this.BindEventFields(response.Table);
                    await this.sleep(800);
                    let promise_GetPostFile = await DataSource.shared.getEventFile(this.selectedEventID);

                    this.arrobj_SelectedFiles = promise_GetPostFile;

                    if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === '99') {
                        console.log('Cannot get event');
                    } else if (response.code === '2') {
                        console.log('invalid ID');
                        window.location.replace('/');
                    }

                    if (this.isStaff === false) {
                        this.joinEventDetails = response.Table[0];
                        let joinStatus = this.EventAllParticipant.find(d => d.eligibleRegistrationAction === "Join");
                        this.$refs['EventShowModalNonStaff'].show();
                    } else if (this.isDisabled === true) {
                        this.$refs['EventShowModal'].show();
                    } else {
                        this.isEditEvent = true;
                        this.editEventID = objValue.EventID;
                        this.$refs['EventShowModal'].show();
                    }
                    this.eventNewEdit('Edit');
                    this.$vs.loading.close();

                } catch (e) {
                    console.log(e);
                }

            },
            async deleteEvent(eventID/*, isSend*/) {
                try {
                    //capture EventID
                    this.selectedEventID = eventID;

                    if (eventID === undefined) {
                        eventID = this.editEventID;
                    }
                    const response = await DataSource.shared.deleteEvent(eventID/*, isSend*/);

                    if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === '99') {
                        console.log('Event Not Found');
                    } else if (response.code === '2') {
                        console.log('invalid ID');
                        window.location.replace('/');
                    } else if (response.code === '1') {
                        // alert('Event Deleted!');
                        this.$notify({
                            title: lang('Success'),
                            message: lang('Event Removed'),
                            type: 'success'
                        });
                        // window.location.replace('/event');
                        this.LoadEventDetails();
                        this.$refs['EventShowModal'].hide();
                    }

                } catch (e) {
                    console.log(e);
                }
            },
            async getLevelSpecificSchool() {
                try {
                    const response = await DataSource.shared.getLevelSpecificSchool(Cookies.get('schoolSession'));
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            this.levelList = response.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async LoadEventDetails() {
                this.$vs.loading();
                try {
                    if (Cookies.get('userTypeSession') === 'Parent') {
                        this.eventDisplayMode = "All";
                    }

                    this.scheduleList = [];
                    // this.calendarList = [];
                    // const response = DataSource.shared.getEvent();
                    const response = DataSource.shared.getEvent(this.eventListDateFrom, this.eventListDateTo);

                    response.then((response) => {
                        this.$vs.loading.close();

                        // console.log(response, "resp");

                        if (response.code === '88') {
                            window.location.replace('/');
                        }

                        if (response.Table) {
                            if (response.Table.length < 1) {
                                alert('No record found');
                                console.log('No record found');
                            } else if (response.code === '99') {
                                alert('No event found');
                                console.log('No event found');
                            } else {
                                this.eventList = (response.Table) ? response.Table : [];
                                if (this.userType === "Teacher") {
                                    this.eventList = this.eventList.filter(a => {
                                        return a.EventType === "PTC" || a.EventType === "Elearning";
                                    });
                                }

                                // pierteachers, classTeacher
                                if (this.eventDisplayMode === "Self") {
                                    this.eventList = this.eventList.filter((eList, eIndex) => {
                                        let arrTeacherIds = [];
                                        if (eList.teachers) {
                                            arrTeacherIds = eList.teachers.split(",");
                                        }

                                        let arrPierteacherIds = [];
                                        if (eList.pierteachers) {
                                            arrPierteacherIds = eList.pierteachers.split(",");
                                        }

                                        let arrClassTeacherIds = [];
                                        if (eList.classTeacher) {
                                            arrClassTeacherIds = eList.classTeacher.split(",");
                                        }

                                        return (eList.EventCreatedBy === Cookies.get('userIDSession') || arrTeacherIds.includes(Cookies.get('userIDSession'))
                                            || arrPierteacherIds.includes(Cookies.get('userIDSession')) || arrClassTeacherIds.includes(Cookies.get('userIDSession')));
                                    });
                                }

                                let arrSelectedPTCEvtID = [];

                                this.eventList.forEach((m) => {
                                      this.arr_parentSplit = [];
                                      let mycolor = '#'+(Math.random()*0xFFFFFF<<0).toString(16);

                                      let timeslotResp = DataSource.shared.getPtcTimeslots(m.EventID);
                                      timeslotResp.then((tsResp) => {
                                        this.$vs.loading.close();

                                        if (tsResp.Table) {
                                              tsResp.Table.forEach((tsVal) => {
                                                  if (tsVal.EventTimeslotEventParID) {
                                                      let tsObject = {
                                                          id: m.EventID,
                                                          calendarId: m.EventType,
                                                          title: '(PTC)'+ tsVal.Full_Name + ' ' + tsVal.EventTimeslotStart,
                                                          category: 'time',
                                                          dueDateClass: '',
                                                          start: new Date(tsVal.EventTimeslotStart.replace(/\s/, 'T')),
                                                          end: new Date(tsVal.EventTimeslotEnd.replace(/\s/, 'T')),
                                                          showContentButton: true,
                                                          showConnectionButton: true,
                                                          showObservationButton: true,
                                                          location: m.EventLocation,
                                                          body:
                                                              "Registration Time: " + m.EventRegistrationStartTime_Convert + "\n" +
                                                              "Registration Limit: " + m.EventRegLimit + "\n" +
                                                              "Registration cutoff(days): " + m.EventRegCutOffDay,
                                                          raw: m.EventCreatedBy
                                                      };

                                                      if (Cookies.get('userTypeSession') === 'Parent' && Cookies.get('userIDSession') === tsVal.CONid) {
                                                          this.arr_parentSplit.push(tsObject);
                                                          arrSelectedPTCEvtID.push(m.EventID);
                                                      }

                                                      if (Cookies.get('userTypeSession') !== 'Parent') {
                                                          this.scheduleList.push(tsObject);
                                                      }
                                                  }
                                              });
                                          }
                                      }).then((resp) => {

                                          let objects = {
                                              id: m.EventID,
                                              calendarId: m.EventType,
                                              // calendarId: m.EventCreatedBy,
                                              title: m.EventTitle,
                                              category: 'time',
                                              dueDateClass: '',
                                              start: new Date(m.EventStartTime.replace(/\s/, 'T')),
                                              end: new Date(m.EventEndTime.replace(/\s/, 'T')),
                                              showContentButton: true,
                                              showConnectionButton: true,
                                              showObservationButton: true,
                                              location: m.EventLocation,
                                              body:
                                                  "Registration Time: " + m.EventRegistrationStartTime_Convert + "\n" +
                                                  "Registration Limit: " + m.EventRegLimit + "\n" +
                                                  "Registration cutoff(days): " + m.EventRegCutOffDay,
                                              raw: m.EventCreatedBy
                                          };

                                          if (Cookies.get('userTypeSession') !== 'Parent') {
                                              this.scheduleList.push(objects);
                                          }

                                          if (Cookies.get('userTypeSession') === 'Parent') {
                                              if (arrSelectedPTCEvtID.includes(m.EventID)) {
                                                  this.arr_parentSplit.forEach((arrSplit) => {
                                                      if (arrSplit.id === m.EventID) {
                                                          this.scheduleList.push(arrSplit);
                                                      }
                                                  });
                                              } else {
                                                  this.scheduleList.push(objects);
                                              }
                                          }
                                      });

                                      // m.start = m.EventCreatedOn_Convert;
                                      // let objects = {
                                      //     id: m.EventID,
                                      //     calendarId: m.EventType,
                                      //     // calendarId: m.EventCreatedBy,
                                      //     title: m.EventTitle,
                                      //     category: 'time',
                                      //     dueDateClass: '',
                                      //     start: new Date(m.EventStartTime.replace(/\s/, 'T')),
                                      //     end: new Date(m.EventEndTime.replace(/\s/, 'T')),
                                      //     showContentButton: true,
                                      //     showConnectionButton: true,
                                      //     showObservationButton: true,
                                      //     location: m.EventLocation,
                                      //     body:
                                      //         "Registration Time: " + m.EventRegistrationStartTime_Convert + "\n" +
                                      //         "Registration Limit: " + m.EventRegLimit + "\n" +
                                      //         "Registration cutoff(days): " + m.EventRegCutOffDay,
                                      //     raw: m.EventCreatedBy
                                      // };
                                      //
                                      // this.scheduleList.push(objects);
                                  });

                            }
                        }

                    });
                } catch (e) {
                    console.log(e);
                }
            },
            async LoadUpComingEvent() {
                try {
                    this.upComingEventList = [];

                    const response = await DataSource.shared.getUpComingEvent();
                    if (response.Table) {
                        if (response.code === '2') {
                            console.log('No record found');
                        } else if (response.code === '99') {
                            console.log('99');
                        } else {
                            // this.upComingEventList = response.Table;
                            this.upComingEventList = (response.Table) ? response.Table : [];
                        }
                    }
                    // response.then((response) => {
                    //
                    //     if (response.code === '2') {
                    //         console.log('No record found');
                    //     } else if (response.code === '99') {
                    //         console.log('99');
                    //     } else {
                    //         this.upComingEventList = (response.Table) ? response.Table : [];
                    //     }
                    // });
                } catch (e) {
                    console.log(e);
                }
            },
            async LoadUpComingEventDetail(value) {
                try {
                    var obj = {
                        EventStartTime: value,
                    };

                    const response = await DataSource.shared.getUpComingEventDetail(JSON.stringify(obj));

                    if (response.code === '99') {
                        console.log('99');
                    } else if (response.code === '2') {
                        console.log('2');
                        alert('No record found');
                    } else {
                        return this.upComingEventDetailList = (response.Table) ? response.Table : [];
                    }

                } catch (e) {
                    console.log(e);
                }
            },
            eventNewEdit(value, res) {
                $(".tui-full-calendar-month-guide-block").remove(); // changes
                if (value === 'New') {
                    this.lblNewEditCalendar = value;
                    this.refreshBModalValue(res);
                    const updateRes = String(res.getFullYear()) +"-"+ String(res.getMonth()+1) +"-"+ String(res.getDate());
                    let todayDate = new Date();
                    let updateDate = String(todayDate.getFullYear()) +"-"+ String(todayDate.getMonth()+1) +"-"+ String(todayDate.getDate());
                    let isBefore = moment(updateDate).isSameOrBefore(updateRes,'day');

                    if (this.isStaff === false) {
                        // this.$refs.EventShowModalNonStaff.show();
                    } else if (isBefore === true) {
                        this.$refs.EventShowModal.show();
                    } else {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please choose another date')
                        });
                    }
                }else if(value === 'NewfromButton'){
                    this.lblNewEditCalendar = 'New';
                    this.refreshBModalValue(res);

                    if (this.isStaff === false) {
                        // this.$refs.EventShowModalNonStaff.show();
                    } else {
                        this.$refs.EventShowModal.show();
                    }
                } else {
                    this.lblNewEditCalendar = value;

                    if (this.isStaff === false) {
                        // this.$refs.EventShowModalNonStaff.show();
                    } else {
                        this.$refs.EventShowModal.show();
                    }
                }

                if (this.isStaff === false) {
                    // this.$refs.EventShowModalNonStaff.show();
                } else {
                    // changes
                    if (moment(new Date(res)).format("YYYY/MM/DD") >= moment().format("YYYY/MM/DD")) {
                        this.$refs.EventShowModal.show();
                    }

                    // this.$refs.EventShowModal.show();
                }

                // if (this.isStaff === false) {
                //     // this.$refs.EventShowModalNonStaff.show();
                // } else {
                //     this.$refs.EventShowModal.show();
                // }
            },
            refreshBModalValue(res) {
                // let getCurrentDateTime = new Date();
                this.isDisabled = false;
                this.inputEventTitle = '';
                this.rdEventType = '';
                this.inputEventTime[0] = new Date(res);
                this.inputEventTime[1] = new Date(res);
                this.inputEventRegLimit = 0;
                this.inputEventRegCutOffDay = 0;
                this.inputEventLocation = '';
                this.optParentSignUp = false;
                this.ParticipantNameListInt = [];
                this.ddlParticipant = '';
                this.CurrentParticipantList = [];
                this.guestInt = [];
                this.studentInt = [];
                this.inputEventRegistrationStartTime = '';
                this.MasterParticipantList.forEach(m => {
                    this.CurrentParticipantList.push(m);
                });
                this.EventDurationHour = '';
                this.arrobj_SelectedFiles = [];

                this.hangoutEventLink = '';
                this.googleCalendarEventID = '';
                this.eventRemark = '';
                this.eventFormat = '';
            },
            showClassModal() {
                this.$refs.addClassModal.show();
            },
            validEmail() {
                const re = /(.+)@(.+){2,}\.(.+){2,}/;
                return re.test(this.inputEventParticipant.toLowerCase());
            },
            removeParticipantList(guest) {
                // this.inputEventParticipantList.splice(this.inputEventParticipantList.indexOf(guest), 1);
                this.guestInt.splice(this.guestInt.indexOf(guest), 1);
            },
            async btnJoinEvent() {
                console.log('btnJoinEvent');
            },
            async btnRejectEvent() {
                console.log('btnRejectEvent');
            },

            //calendar
            init() {
                this.setRenderRangeText();
                this.checkRouterID();
                this.getMonthDay();
            },
            checkRouterID() {
                if (this.$route.query.id) {
                    let feedEventID = this.$route.query.id;
                    let item =
                        {
                            "EventID": feedEventID,
                            "EventCreatedBy": "",
                        };
                    this.editEvent(item);
                }
            },
            setRenderRangeText() {
                this.dateRange = "";

                const {invoke} = (this.eventDisplayMode === "Self" ? this.$refs.tuiCalSelf : this.$refs.tuiCalAll);

                // const {invoke} = this.$refs.tuiCal;
                const view = invoke('getViewName');
                const calDate = invoke('getDate');
                const rangeStart = invoke('getDateRangeStart');
                const rangeEnd = invoke('getDateRangeEnd');
                let year = calDate.getFullYear();
                let month = calDate.getMonth() + 1;
                let date = calDate.getDate();
                let dateRangeText = '';
                let endMonth, endDate, start, end;
                switch (view) {
                    case 'month':
                        dateRangeText = `${year}-${month}`;
                        break;
                    case 'week':
                        year = rangeStart.getFullYear();
                        month = rangeStart.getMonth() + 1;
                        date = rangeStart.getDate();
                        endMonth = rangeEnd.getMonth() + 1;
                        endDate = rangeEnd.getDate();
                        start = `${year}-${month}-${date}`;
                        end = `${endMonth}-${endDate}`;
                        // dateRangeText = `${start} ~ ${end}`;
                        dateRangeText = `${year}-${month}`; // changes
                        break;
                    default:
                        dateRangeText = `${year} ${month} ${date}`;
                }

                if (view === "day") {
                    this.dateRange = moment(dateRangeText, "YYYY MM DD").format('YYYY MMMM ');
                } else {
                    this.dateRange = moment(dateRangeText, "YYYY-MM").format('YYYY MMMM ');
                }
                // this.dateRange = moment(dateRangeText).format('YYYY MMMM ');
            },
            onClickNavi(event) {
                const {target} = event;
                let action = target.dataset ? target.dataset.action : target.getAttribute('data-action');
                if (action) {
                    action = action.replace('move-', '');
                    if (this.eventDisplayMode === "Self") {
                        this.$refs.tuiCalSelf.invoke(action);
                    } else {
                        this.$refs.tuiCalAll.invoke(action);
                    }
                    // this.$refs.tuiCal.invoke(action);
                    this.setRenderRangeText();

                    this.getMonthDay();
                }
            },
            beforeCreateSchedule(res) {
                this.inputEventTime[0] = new Date(res.start);
                this.inputEventTime[1] = new Date(res.start);
                this.eventNewEdit('New', res.start);
            },
            onClickSchedule(res) {
                let item =
                    {
                        "EventID": res.schedule.id,
                        "EventCreatedBy": res.schedule.raw,
                    };
                this.editEvent(item);
            },
            //check user
            checkUser() {
                this.checkedUser = Cookies.get('userTypeSession');
            },

            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },

            showUpComing(type) {
                if (type === "calendar") {
                    this.showLatest = false;
                } else {
                    this.showLatest = true;
                }

                if (this.showLatest) {
                    this.LoadUpComingEvent();
                }
            },

            convertDatetimeFormat(datetimeVal) {
                return moment(datetimeVal).format("DD/MM/YYYY HH:mm");
                // return moment(datetimeVal).format("DD/MM/YYYY HH:mm:ss");
            },

            // for parent
            showEndResultModal() {
                this.$refs['parentShowEndResultModal'].show();
            },

            hideEndResultModal() {
                this.$refs['parentShowEndResultModal'].hide();

                this.clearEndResult();
            },

            onFileChanged(event) {
                // this.$vs.loading();

                this.arr_EndResultSelectedFileList = [];

                this.isUploadFile = true;
                for (let file of event.target.files) {
                    let fileSize = file.size / 1024 / 1024;
                    if (fileSize > 10) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('File limit exceeded 10MB')
                        });
                    } else {
                        if (this.isWhitelist(file)) {
                            // this.arrobj_SelectedFiles = event.target.files;
                            this.arr_EndResultSelectedFileList = event.target.files;
                        } else {
                            this.$notify.error({
                                title: lang('Error'),
                                message: lang('File Format Not Accepted')
                            });
                        }
                    }
                }

                if (this.arr_EndResultSelectedFileList && this.arr_EndResultSelectedFileList.length > 0) {
                    // this.$vs.loading.close();
                    this.changeSelectedFilesFormat();
                }
            },

            async loadWhitelist() {
                await DataSource.shared.getWhitelist().then((result) => {
                    this.arrstr_Whitelist = result.Table;
                });
            },

            isWhitelist(file) {
                let temparrstr = file.name.split(".");
                let str_Ext = ("." + temparrstr[temparrstr.length - 1]).toUpperCase();
                let isWhitelisted = this.arrstr_Whitelist.findIndex(x => x.ext.toUpperCase() === str_Ext) !== -1;
                let isValidFile = file.size > 0;

                return (isWhitelisted && isValidFile);
            },

            changeSelectedFilesFormat() {
                for (let a = 0; a < this.arr_EndResultSelectedFileList.length; a++) {
                    this.arrobj_EndResultSelectedFiles.push(this.arr_EndResultSelectedFileList[a]);
                }
                this.convertSelectedFilesToFileFormat();
            },

            convertSelectedFilesToFileFormat() {
                this.convertedFileForInsert = [];
                this.arrobj_EndResultSelectedFiles.forEach((images) => {
                    if (images.name === undefined) {
                        let url = "data:" + images.EventFileType + ";base64," + images.EventFileOriginal;
                        let fileName = images.EventFIleName;
                        let mimeType = images.EventFileType;
                        this.urltoFile(url, fileName, mimeType).then((file) => {
                            this.convertedFileForInsert.push(file);
                        }).finally(() => {
                            this.getImagePreviews();
                        });
                    } else {
                        this.convertedFileForInsert.push(images);
                    }
                });

            },

            getImagePreviews() {
                /*
                  Iterate over all of the files and generate an image preview for each one.
                */
                for (let i = 0; i < this.arrobj_EndResultSelectedFiles.length; i++) {
                    /*
                      Ensure the file is an image file
                    */
                    if (/\.(jpe?g|png|gif)$/i.test(this.arrobj_EndResultSelectedFiles[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            if (this.$refs['image' + parseInt(i)]) {
                                this.$refs['image' + parseInt(i)][0].src = reader.result;
                            }
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.arrobj_EndResultSelectedFiles[i]);
                    }
                }
            },

            cancelFiles(obj, objKey) {

                let fileName = (obj.EventFIleName) ? obj.EventFIleName : obj.name;

                this.arrobj_EndResultSelectedFiles = this.arrobj_EndResultSelectedFiles.filter((d, dIndex) => {
                    let eachName = (d.EventFIleName) ? d.EventFIleName : d.name;
                    let isValid = true;
                    if (objKey === dIndex && eachName === fileName) {
                        isValid = false;
                    }

                    return isValid;
                });

                this.convertSelectedFilesToFileFormat();
            },

            clearEndResult() {
                this.ddlEndResultEventID = "";
                this.endResultRemarks = "";
                this.arr_EndResultSelectedFileList = [];
                this.arrobj_EndResultSelectedFiles = [];

                $("#FU_Portfolio").val("");
            },

            async createEndResult() {

                if (this.ddlEndResultEventID === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: lang('Please select event'),
                    });

                    return;
                }

                // if () {
                //
                // }
                // if (this.arrobj_EndResultSelectedFiles.length === 0) {
                //     this.$notify.error({
                //         title: lang('Error'),
                //         message: lang('Please upload files'),
                //     });
                // }

                this.$vs.loading();

                try {
                    let response = await DataSource.shared.saveEndResult(this.arrobj_EndResultSelectedFiles, this.ddlEndResultEventID, this.endResultRemarks);

                    if (response) {
                        if (response.code === '88') {
                            console.log('88');
                            window.location.replace('/');
                        } else if (response.code === "99") {
                            console.log('99');
                        } else if (response.code === '1') {
                            this.$notify({
                                title: lang('Success'),
                                message: "Successfully Added Postback!",
                                type: 'success'
                            });
                        }

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    console.log(e);
                }

            },
            // for Parent

            // for Staff
            async changeEventsStatus(displayMode) {
                this.eventDisplayMode = displayMode;
                this.isStaff = true;
                await this.init();
                // await this.LoadEventDetails();
                // await this.LoadUpComingEvent();
                // await this.getLevelSpecificSchool();
            },

            viewPostbackPage() {
                // this.$router.push({
                //     name: 'EventPostBack',
                //     params: {
                //         paramEventList: this.eventList,
                //     }
                // });
                this.isPostback = true;
            },

            getMonthDay() {
                const {invoke} = (this.eventDisplayMode === "Self" ? this.$refs.tuiCalSelf : this.$refs.tuiCalAll);
                // const {invoke} = this.$refs.tuiCal;
                const calDate = invoke('getDate');
                let year = calDate.getFullYear();
                let month = calDate.getMonth() + 1;
                let date = calDate.getDate();

                let startOfMonth = "";
                let endOfMonth = "";
                let fullDate = date+"/"+month+"/"+year;
                fullDate = moment(fullDate, "DD/M/YYYY").format("DD/MM/YYYY");

                startOfMonth = moment(fullDate, "DD/MM/YYYY").startOf("month").format("DD/MM/YYYY");
                endOfMonth = moment(fullDate, "DD/MM/YYYY").endOf("month").format("DD/MM/YYYY");

                this.eventListDateFrom = startOfMonth;
                this.eventListDateTo = endOfMonth;

                // console.log(this.eventListDateFrom, "from", this.eventListDateTo , "To");
                this.LoadEventDetails();
            },

            showCopyEventModal() {
                this.evtMinDate = moment().toISOString();
                this.clearCopyEvent();

                this.$refs['copyEventModal'].show();
            },

            hideCopyEventModal() {
                this.$refs['copyEventModal'].hide();
            },

            async changeSelectedEvent() {
                const response = await DataSource.shared.getEventDetails(this.eventCopyEventID);
                this.refreshBModalValue(response);
                this.BindEventFields(response.Table);
                await this.sleep(800);
                let promise_GetPostFile = await DataSource.shared.getEventFile(this.eventCopyEventID);

                // this.copyEventFiles = promise_GetPostFile;

                this.copyEventFiles = [];
                if (promise_GetPostFile.Table && promise_GetPostFile.Table.length > 0) {
                    for (let image of promise_GetPostFile.Table) {
                        let url = "data:" + image.EventFileType + ";base64," + image.EventFileOriginal;
                        let fileName = image.EventFIleName;
                        let mimeType = image.EventFileType;
                        this.urltoFile(url, fileName, mimeType).then((file) => {
                            this.copyEventFiles.push(file);
                        });
                    }
                }

                if (response.code === '88') {
                    window.location.replace('/');
                } else if (response.code === '99') {
                    console.log('Cannot get event');
                } else if (response.code === '2') {
                    console.log('invalid ID');
                    window.location.replace('/');
                }

                this.copyEventData = response.Table[0];

                // console.log(this.copyEventFiles, this.copyEventData, "chekingasdas");
            },

            addCopyDatetime() {
                if (this.evtStartDatetime !== "" && this.evtEndDatetime !== "") {
                    let obj = {};
                    obj.copyStart = this.evtStartDatetime;
                    obj.copyEnd = this.evtEndDatetime;
                    this.copyEventDateList.push(obj);

                    this.evtStartDatetime = "";
                    this.evtEndDatetime = "";
                }
            },

            removeCopyDate(selectedDatetime) {
                this.copyEventDateList.splice(this.copyEventDateList.indexOf(selectedDatetime), 1);
            },

            async copyEvent() {
                try {
                    if (this.eventCopyEventID === "") {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select event!'),
                        });
                    } else if (this.isNull(this.copyEventDateList)) {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Please select start and end datetime!'),
                        });
                    } else {
                        this.$vs.loading();

                        this.copyEventDateList.forEach((object, index) => {
                            this.copyStartDatetime = moment(object.copyStart).format("DD/MM/YYYY HH:mm:ss");
                            this.copyEndDatetime = moment(object.copyEnd).format("DD/MM/YYYY HH:mm:ss");

                            let Obj = {
                                EventTitle: this.copyEventData.EventTitle,
                                EventType: this.copyEventData.EventType,
                                EventStartTime: this.copyStartDatetime,
                                EventEndTime: this.copyEndDatetime,
                                EventRegistrationStartTime: "",
                                // EventRegistrationStartTime: this.inputEventRegistrationStartTime,
                                EventParentSignUp: this.copyEventData.EventParentSignUp,
                                EventRegCutOffDay: this.copyEventData.EventRegCutOffDay,
                                EventRegLimit: this.copyEventData.EventRegLimit,
                                EventLocation: "",
                                EventDuration: "",

                                EventLink: "",
                                EventCalendarID: "",
                                EventRemarks: (this.copyEventData.EventRemarks ? this.copyEventData.EventRemarks : ""),
                                EventFormat: (this.copyEventData.EventFormat ? this.copyEventData.EventFormat : ""),
                            };

                            let guestIntSave = [];
                            guestIntSave.push(...this.guestInt);
                            if (this.studentInt) {
                                this.studentInt.forEach(item => {
                                    let participantListDetail = {
                                        Type: 'Student',
                                        value: item.value,
                                    };
                                    guestIntSave.push(participantListDetail);
                                });
                            }

                            if (this.schID === "SCH201400000480" || this.schID === "SCH201400000510") {
                                let randomRequestID = Math.random().toString(36).substring(2, 15);
                                Obj.EventLink = "https://meet.google.com/lookup/"+randomRequestID;
                                Obj.EventCalendarID = randomRequestID;
                                let response = {};
                                try {
                                    response = DataSource.shared.saveEvent(this.copyEventFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave));
                                } catch (e) {
                                    console.log(e);
                                }

                                response.then((savedValue) => {

                                    if (savedValue.code === '88') {
                                        console.log('88');
                                        window.location.replace('/');
                                    } else if (savedValue.code === "99") {
                                        console.log('99');
                                    } else if (savedValue.code === '1') {
                                        this.$notify({
                                            title: lang('Success'),
                                            message: lang('Event Added'),
                                            type: 'success'
                                        });
                                    }

                                    // this.$vs.loading.close();
                                }).finally(() => {
                                    if ( (index+1) === this.copyEventDateList.length) {
                                        this.LoadEventDetails();
                                        this.$vs.loading.close();
                                    }
                                });
                            } else {
                                this.newGoogleCalendarEvent().then((resp) => {

                                    if (resp) {
                                        Obj.EventLink = this.createdGoogleCalendarEventLink;
                                        Obj.EventCalendarID = this.createdGoogleCalendarID;
                                        let response = {};
                                        try {
                                            response = DataSource.shared.saveEvent(this.copyEventFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave));
                                        } catch (e) {
                                            console.log(e);
                                        }

                                        response.then((savedValue) => {

                                            if (savedValue.code === '88') {
                                                console.log('88');
                                                window.location.replace('/');
                                            } else if (savedValue.code === "99") {
                                                console.log('99');
                                            } else if (savedValue.code === '1') {
                                                this.$notify({
                                                    title: lang('Success'),
                                                    message: lang('Event Added'),
                                                    type: 'success'
                                                });

                                                // if ( (index+1) === this.copyEventDateList.length && savedValue.code ) {
                                                //     this.LoadEventDetails();
                                                // }
                                                // this.LoadEventDetails();
                                            }

                                            // this.$vs.loading.close();
                                        });

                                    } else {
                                        this.$notify.error({
                                            title: lang('Error'),
                                            message: lang('Integration problems!'),
                                        });
                                    }

                                }).finally(() => {
                                    if ( (index+1) === this.copyEventDateList.length) {
                                        this.LoadEventDetails();
                                        this.$vs.loading.close();
                                    }
                                });
                            }


                        });

                        this.hideCopyEventModal();
                    }
                } catch (e) {
                    console.log(e, "copy error msg!");
                }
            },

            clearCopyEvent() {
                this.eventCopyEventID = "";
                this.evtStartDatetime = "";
                this.evtEndDatetime = "";
                this.copyEventDateList = [];
            },

            async newGoogleCalendarEvent() {
                let creatorEmail = Cookies.get('userEmailSession');
                let randomRequestID = (this.copyEventData.EventType === 'Elearning') ? Math.random().toString(36).substring(2, 15) : "";
                let calendarStartDatetime = moment(this.copyStartDatetime, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                let calendarEndDatetime = moment(this.copyEndDatetime, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
                let generateType = (this.copyEventData.EventType === "Event") ? "normal" : (this.copyEventData.EventType === "Elearning") ? "normalWithLink" : "";

                let googleCalendarResp = await DataSource.shared.createGoogleCalendarEvent(creatorEmail, this.copyEventData.EventTitle,
                    "", "", calendarStartDatetime, calendarEndDatetime, randomRequestID, "", generateType);

                if (googleCalendarResp) {
                    this.createdGoogleCalendarID = googleCalendarResp.id;
                    this.createdGoogleCalendarEventLink = googleCalendarResp.hangoutLink;
                }

                return googleCalendarResp;
            },

            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            return new File([buf], filename, {type: mimeType});
                        })
                );
            },

            async getServerCurrentDatetime() {
                await DataSource.shared.getServerCurrentDatetime().then((result) => {
                    this.serverCurrentDatetime = result;
                });
            },

            changeCalendarDisplayType(type) {
                this.selectedView = type;
                if (this.eventDisplayMode === "Self") {
                    this.$refs.tuiCalSelf.invoke('changeView', type, true);
                } else {
                    this.$refs.tuiCalAll.invoke('changeView', type, true);
                }
                // this.$refs.tuiCal.invoke('changeView', newValue, true);
                this.setRenderRangeText();
            },

            onChangeNavi(action) {
                if (action) {
                    if (this.eventDisplayMode === "Self") {
                        this.$refs.tuiCalSelf.invoke(action);
                    } else {
                        this.$refs.tuiCalAll.invoke(action);
                    }
                    // this.$refs.tuiCal.invoke(action);
                    this.setRenderRangeText();

                    this.getMonthDay();
                }
            },

            changePostbackSelectedEvent() {
                this.loadEventPostback();
            },

            async loadEventPostback() {
                this.$vs.loading();

                try {
                    let response = await DataSource.shared.getEventPostBack(this.postBackSelectedEventID, this.selectedDisplayMode);

                    if (response) {
                        if (response.code === '99') {
                            console.log(response.code);
                            return;
                        }

                        if (response.code === '88') {
                            window.location.replace('/');
                            return;
                        }

                        // EventPbRemarks, CONname, EventPbCreatedOn,
                        if (response.Table) {

                            response.Table.forEach(pbItem => {
                                let pbFiles = DataSource.shared.getEventPostBackFile(pbItem.EventPbID);

                                this.allPBIDs.push(pbItem.EventPbID);

                                pbItem.pbAllFiles = [];
                                pbFiles.then((pbFiles) => {
                                    if (pbFiles.Table) {
                                        pbItem.pbAllFiles = pbFiles.Table;
                                    }
                                });
                            });

                            this.eventPostBackList = response.Table;

                            let sortedList = this.groupBy(this.eventPostBackList, "EventPbCreatedBy", "CONname");

                            this.eventGroupPostBackList = sortedList;
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e);
                }
            },

            groupBy(data, key, display) {
                let ArrObj_Sorted = [];
                let arrstr_display = !this.isNull(display) ? display.split(",") : [key];

                for (let item of data) {
                    let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key]);

                    if (index === -1) {
                        let str_Display = "";
                        for (let tempdisp of arrstr_display)
                            str_Display += item[tempdisp] + " ";

                        ArrObj_Sorted.push({Str_SortBy: item[key], Str_Display: str_Display, ArrObj_Items: [item]});
                    } else
                        ArrObj_Sorted[index].ArrObj_Items.push(item);
                }

                return ArrObj_Sorted;
            },

            getFile(file) {
                return `data:${file.EventPbfFileType};base64,${file.EventPbfItem}`;
            },

            convertDatetime(datetimeVal) {
                return moment(datetimeVal).format("DD MMM YYYY HH:mm:ss");
            },

            async downloadEach(createdBy) {
                try {
                    this.$vs.loading();

                    const resp = await DataSource.shared.getAllEventPostBackZipFile(this.postBackSelectedEventID, createdBy);

                    if (response.code === '88') {
                        window.location.replace('/');
                        return;
                    }

                    if (resp.code === '99') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Cannot download files!'
                        });
                    } else {
                        let byteChar = atob(resp.code);
                        let byteNo = new Array(byteChar.length);
                        for (let i = 0; i < byteChar.length; i++) {
                            byteNo[i] = byteChar.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNo);
                        let file = new Blob([byteArray], {type: 'application/zip;base64'});
                        let fileUrl = URL.createObjectURL(file);
                        window.location.href = fileUrl;
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e, "zip error msg!");
                }
            },

            async downloadAsZip() {
                try {
                    this.$vs.loading();

                    const resp = await DataSource.shared.getAllEventPostBackZipFile(this.postBackSelectedEventID, "");
                    // console.log(resp, "resp");

                    if (response.code === '88') {
                        window.location.replace('/');
                        return;
                    }

                    if (resp.code === '99') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Cannot download files!'
                        });
                    } else {
                        let byteChar = atob(resp.code);
                        let byteNo = new Array(byteChar.length);
                        for (let i = 0; i < byteChar.length; i++) {
                            byteNo[i] = byteChar.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNo);
                        let file = new Blob([byteArray], {type: 'application/zip;base64'});
                        let fileUrl = URL.createObjectURL(file);
                        window.location.href = fileUrl;
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e, "zip error msg!");
                }
            },

            /*#region Page tour*/
            eventPageVueTourStart() {
                this.$tours['EventPageVueTourName'].start();
            },

            eventPageVueTourCallBacksPreviousSteps(currentStep) {
                let finalSteps = currentStep - 1;
            },

            eventPageVueTourCallBacksNextSteps(currentStep) {
                let finalSteps = currentStep + 1;
            },
            /*#endregion*/
        },
        destroyed () {
            window.removeEventListener('resize', this.isMobile);
        },
    };
</script>

<style scoped>
    .web-version-div {
        text-align: left;
    }

    .web-version-div .event-page-title {
        display: inline-block!important;
        margin-right: 10px;
        font-size: 18px;
        margin-bottom: 0px;
        font-weight: normal;
        vertical-align: middle;
    }

    .web-version-div .btn-tutorial {
        background: #C9D5FF;
        border-radius: 5px;
    }

    .web-version-div .btn-tutorial span a {
        color: #426DFF;
        vertical-align: middle;
        /*margin-left: 5px;*/
    }

    .web-version-div .btn-create-calendar {
        background: #EA4C89;
        border-radius: 5px;
    }

    .web-version-div .btn-create-calendar span {
        color: #FFFFFF;
        vertical-align: middle;
        margin-left: 5px;
    }

    .web-version-div .calendar-header-left,
    .web-version-div .calendar-header-right {
        display: inline-block;
    }

    .web-version-div .calendar-header {
        background: #426DFF;
        min-height: 44px;
        padding: 10px 15px;
    }

    .web-version-div .btn-prev-calendar {
        background: #364DCD;
        border-radius: 2px;
        position: relative;
        height: 23px;
    }

    .web-version-div .btn-prev-calendar i {
        color: #FFFFFF;
        position: absolute;
        top: 2px;
        right: 10px;
    }

    .web-version-div .btn-next-calendar {
        background: #364DCD;
        border-radius: 2px;
        position: relative;
        height: 23px;
    }

    .web-version-div .btn-next-calendar i {
        color: #FFFFFF;
        position: absolute;
        top: 2px;
        left: 10px;
    }

    .web-version-div .calendar-showing-date {
        color: #FFFFFF;
        margin: 0px 10px;
    }

    .web-version-div .calendar-display-type {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
    }

    .web-version-div .common-display-type {
        margin-right: 5px;
        cursor: pointer;
    }

    .web-version-div .btn-today {
        background: #EA4C89;
        border-radius: 2px;
        height: 23px;
        margin-right: 10px;
        font-size: 12px;
        padding: 2px 10px;
    }

    .web-version-div .btn-postback {
        background: #364DCD;
        border-radius: 2px;
        height: 23px;
        margin-right: 10px;
        font-size: 12px;
        padding: 2px 10px;
    }

    .web-version-div .btn-copy {
        background: #364DCD;
        border-radius: 2px;
        height: 23px;
        font-size: 12px;
        padding: 2px 10px;
    }

    .web-version-div .upcoming-list {
        padding: 0px;
    }

    .web-version-div .calendar-header-right {
        text-align: right;
        vertical-align: top;
    }

    .web-version-div .calendar-view,
    .web-version-div .calendar-list-view {
        display: inline-block;
        cursor: pointer;
    }

    .parent-postback-list-container {
        /*width: 325px;*/
        width: 20%;
        display: inline-block;
        background: white;
        position: sticky;
        top: 0px;
        border-radius: 8px;
        vertical-align: top;
        align-self: flex-start;
        min-height: calc(100vh - 70px);
        margin-right: 20px;
    }

    .postback-content-container {
        width: calc(100% - 25%);
        vertical-align: top;
        display: inline-block;
        margin: 0 auto;
    }

    .sans-font-style-size-18 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 21px;
    }

    .sans-font-style-size-22 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 26px;
    }
</style>

<style>
    .eventPageBTabs .nav-tabs .nav-link.active {
        background-color: #426DFF;
        border-color: #426DFF #426DFF;
        color: #ffffff;
    }

    .latestEventList thead tr th {
        background: #E9EDF7;
    }

    .latestEventList tbody tr {
        background: #F8FAFF;
    }

    .latestEventList table td {
        padding: 5px 0;
    }

    #copyEventModal .modal-body {
        padding: 0px;
    }
</style>